document.addEventListener("DOMContentLoaded", function () {
  var sliders = document.querySelectorAll(".members_bg_slider");
  // ループを安定させるため、各スライダーに最低限確保するスライド枚数
  var minSlideCount = 12;
  // 3つのスライダーを同じ等速で動かすため、speed は共通値にする
  var sliderSpeed = 8000;
  // Sass の m.vw() と同じ比率で使うスライド間の余白
  var slideSpacePc = 20;
  var slideSpaceSp = 10;
  var breakpoint = 768;

  if (!sliders.length || typeof window.Swiper === "undefined") return;

  // スライド枚数が少ない場合でも無限ループが途切れないように複製する
  var fillLoopSlides = function (slider) {
    var wrapper = slider.querySelector(".swiper-wrapper");
    if (!wrapper) return;

    var baseSlides = Array.prototype.slice.call(
      wrapper.querySelectorAll(".swiper-slide"),
    );
    if (!baseSlides.length) return;

    for (var i = baseSlides.length; i < minSlideCount; i++) {
      wrapper.appendChild(baseSlides[i % baseSlides.length].cloneNode(true));
    }
  };

  // Sass の m.vw() と同じ計算で、Swiper に渡す px 値へ変換する
  var getVwPx = function (value) {
    var vwBase = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue("--vw-base"),
    );

    return (value * window.innerWidth) / vwBase;
  };

  var getSlideSpace = function () {
    return window.innerWidth >= breakpoint ? slideSpacePc : slideSpaceSp;
  };

  sliders.forEach(function (slider) {
    // 2段目だけ逆方向に流す
    var isReverse = slider.classList.contains("--type_2");

    fillLoopSlides(slider);

    new window.Swiper(slider, {
      loop: true,
      // 逆方向は初期位置がループ境界に近いと、初回の loopFix で速度が乱れることがある
      initialSlide: isReverse ? minSlideCount - 1 : 0,
      slidesPerView: 3.5,
      breakpoints: {
        768: {
          slidesPerView: 6,
        },
      },
      spaceBetween: getVwPx(getSlideSpace()),
      speed: sliderSpeed,
      // 背景演出用のため、ユーザー操作によるスライド移動は無効にする
      allowTouchMove: false,
      autoplay: {
        // delay 0 と linear 指定で、止まらず等速に流れる見た目にする
        delay: 0,
        disableOnInteraction: false,
        reverseDirection: isReverse,
      },
      on: {
        init: function (swiper) {
          swiper.wrapperEl.style.transitionTimingFunction = "linear";
        },
        setTransition: function (swiper) {
          swiper.wrapperEl.style.transitionTimingFunction = "linear";
        },
        resize: function (swiper) {
          // 画面幅変更時に PC/SP に応じた余白を再計算する
          swiper.params.spaceBetween = getVwPx(getSlideSpace());
          swiper.update();
        },
      },
    });
  });
});
